import React, { useEffect } from 'react';
import VexEditor from './components/VexEditor';
import { getUrlParam } from './utils/helpers';
import wx from 'weixin-js-sdk';
import VexViewer from './components/VexViewer';

function App() {
  useEffect(() => {
    const openid = getUrlParam('openid');

    if (!openid) {
      wx.miniProgram.navigateTo({url: '/pages/home/home?action=login'});
    }
  }, []);

  const onlyview = getUrlParam('onlyview');

  if (onlyview) {
    return <VexViewer />
  }

  return (
     <VexEditor /> 
  );
}

export default App;
